import { Badge, Button, ErrorMessage, Spinner } from "../../../../../widgets";

import { FC } from "react";
import { FetchStatus } from "../../../../../base/types";
import { IControlAttributes } from "../../../../../base/models";
import { useReloadButtonProperties } from "./ReloadButtonProperties";

export const DraftReloadButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error, draftText } = useReloadButtonProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return (
        <div className={"inline-block position-relative"}>
            <Badge
                className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
                badgeStyle="primary">
                Reset Button
            </Badge>
            <Button className={className} iconClassName="me-1" {...properties} label={draftText}>
                {children}
            </Button>
        </div>)
}